const STORAGE_KEY = 'bizy-conversation-titles';
const MAX_ENTRIES = 50;

type TitleCache = Record<string, string>;

function loadCache(): TitleCache {
	try {
		const stored = localStorage.getItem(STORAGE_KEY);
		return stored ? JSON.parse(stored) : {};
	} catch {
		return {};
	}
}

function saveCache(cache: TitleCache): void {
	try {
		const entries = Object.entries(cache);
		const trimmed = entries.length > MAX_ENTRIES ? Object.fromEntries(entries.slice(-MAX_ENTRIES)) : cache;
		localStorage.setItem(STORAGE_KEY, JSON.stringify(trimmed));
	} catch {
		// Gracefully handle localStorage errors
	}
}

export function getCachedTitle(conversationId: string): string | undefined {
	return loadCache()[conversationId];
}

export function setCachedTitle(conversationId: string, title: string): void {
	const cache = loadCache();
	cache[conversationId] = title;
	saveCache(cache);
}

export function removeCachedTitle(conversationId: string): void {
	const cache = loadCache();
	delete cache[conversationId];
	saveCache(cache);
}
